const topLoader = () => {
  if (window.TopLoader?.initialized) {
    return window.TopLoader;
  }

  // ---- Minimalny „NProgress” ----
  const bar = () => document.getElementById('top-loader');
  let running = false;
  let trickleTimer = null;
  let hideTimer = null;
  let navigationTimer = null;
  let progress = 0;

  function show() {
    const el = bar();
    if (!el) {
      return;
    }
    el.classList.remove('opacity-0');
  }

  function hide() {
    const el = bar();
    if (!el) {
      return;
    }
    el.classList.add('opacity-0');
    el.style.width = '0%';
    progress = 0;
  }

  function set(p) {
    const el = bar();
    if (!el) {
      return;
    }
    progress = Math.max(0, Math.min(100, p));
    el.style.width = `${progress}%`;
  }

  function startTrickling() {
    if (trickleTimer) {
      return;
    }

    trickleTimer = setInterval(() => {
      if (progress < 90) {
        set(progress + Math.random() * 3 + 1);
      }
    }, 400);
  }

  function start() {
    clearTimeout(hideTimer);
    hideTimer = null;

    if (running) {
      show();
      if (progress >= 100) {
        set(8);
      }
      startTrickling();
      return;
    }

    running = true;
    show();
    set(8); // szybki „ping”
    // delikatne „sączenie” do ~90%
    startTrickling();
  }

  // ---- Licznik żądań AJAX (fetch + XHR) ----
  const activeRequests = new Set();

  function done(force = false) {
    if (!force && activeRequests.size > 0) {
      return;
    }

    if (!running) {
      return;
    }

    clearInterval(trickleTimer);
    trickleTimer = null;
    clearTimeout(hideTimer);
    set(100);

    hideTimer = setTimeout(() => {
      hideTimer = null;

      // Nowe żądanie mogło wystartować podczas animacji kończącej.
      if (!force && activeRequests.size > 0) {
        start();
        return;
      }

      hide();
      running = false;
    }, 250);
  }

  function inc() {
    const requestToken = {};
    activeRequests.add(requestToken);
    start();
    return requestToken;
  }

  function dec(requestToken) {
    if (!activeRequests.delete(requestToken)) {
      return;
    }

    if (activeRequests.size === 0) {
      done();
    }
  }

  // Patch fetch
  if (window.fetch) {
    const nativeFetch = window.fetch;
    window.fetch = function trackedFetch(...args) {
      const requestToken = inc();

      try {
        return Promise.resolve(nativeFetch.apply(this, args))
          .finally(() => dec(requestToken));
      } catch (error) {
        dec(requestToken);
        throw error;
      }
    };
  }

  // Patch XHR
  {
    const nativeOpen = XMLHttpRequest.prototype.open;
    const nativeSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function trackedOpen(...args) {
      this.topLoaderTracked = true;
      return nativeOpen.apply(this, args);
    };
    XMLHttpRequest.prototype.send = function trackedSend(...args) {
      if (!this.topLoaderTracked) {
        return nativeSend.apply(this, args);
      }

      const requestToken = inc();
      let completed = false;
      const complete = () => {
        if (completed) {
          return;
        }

        completed = true;
        dec(requestToken);
      };

      this.addEventListener('loadend', complete, { once: true });

      try {
        return nativeSend.apply(this, args);
      } catch (error) {
        this.removeEventListener('loadend', complete);
        complete();
        throw error;
      }
    };
  }

  // ---- Przejścia między stronami ----
  const STORAGE_KEY = 'topLoader:showOnNext';

  // 1) Na klik linka/form – start + flaga dla kolejnej strony:
  function shouldSkipClick(e, a) {
    // nowe karty / modyfikatory / download / inne domeny opcjonalnie
    return e.defaultPrevented
      || e.button !== 0
      || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey
      || (a && (
        a.target === '_blank'
        || a.hasAttribute('download')
        || a.hasAttribute('data-bs-toggle')
        || a.hasAttribute('data-bs-dismiss')
      ));
  }

  function beginNavigation() {
    sessionStorage.setItem(STORAGE_KEY, '1');
    start();

    clearTimeout(navigationTimer);
    navigationTimer = setTimeout(() => {
      // Jeżeli dokument nadal istnieje, nawigacja została anulowana albo nie doszła do skutku.
      sessionStorage.removeItem(STORAGE_KEY);
      if (activeRequests.size === 0) {
        done();
      }
    }, 15000);
  }

  // Obsługa na window w fazie bubble działa po delegowanych handlerach aplikacji.
  // Dzięki temu widać już preventDefault() używane przez widoki ładowane AJAX-em.
  window.addEventListener('click', (e) => {
    const a = e.target.closest('a[href]');
    if (!a || shouldSkipClick(e, a)) {
      return;
    }

    // Jeśli nawigacja wewnętrzna (ten sam origin) – pokaż pasek
    try {
      const href = a.getAttribute('href')?.trim();
      const url = new URL(a.href, window.location.href);
      const isCurrentDocumentHash = Boolean(url.hash)
        && url.pathname === window.location.pathname
        && url.search === window.location.search;

      if (url.origin !== window.location.origin
        || !['http:', 'https:'].includes(url.protocol)
        || href?.startsWith('#')
        || isCurrentDocumentHash) {
        return;
      }
    } catch (_) { /* ignore */
      return;
    }

    beginNavigation();
    // nie zatrzymujemy nawigacji – po prostu pokazujemy pasek
  });

  window.addEventListener('submit', (e) => {
    const form = e.target;
    if (e.defaultPrevented
      || !(form instanceof HTMLFormElement)
      || form.target === '_blank') {
      return;
    }

    beginNavigation();
  });

  // 2) Jeśli strona wczytuje się z bfcache (wstecz/dalej) → szybko zakończ:
  window.addEventListener('pageshow', (e) => {
    if (e.persisted) {
      sessionStorage.removeItem(STORAGE_KEY);
      done(true);
    }
  });

  // 3) Na nowej stronie – jeśli była flaga, kontynuuj do „load”
  if (sessionStorage.getItem(STORAGE_KEY)) {
    // Zacznij wcześnie (skrypt w <head>)
    start();
    // Trochę „realizmu”: skok do 20% po DOMContentLoaded, zakończ po load
    const markDomReady = () => {
      if (progress < 20) set(20);
    };
    const finishNavigation = () => {
      sessionStorage.removeItem(STORAGE_KEY);
      done();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', markDomReady, { once: true });
    } else {
      markDomReady();
    }

    if (document.readyState === 'complete') {
      finishNavigation();
    } else {
      window.addEventListener('load', finishNavigation, { once: true });
    }

    // Gdyby „load” nie nadszedł (np. SPA/partial), ustaw bezpieczny timeout:
    setTimeout(() => {
      sessionStorage.removeItem(STORAGE_KEY);
      if (activeRequests.size === 0) {
        done();
      }
    }, 15000);
  }

  // API opcjonalnie globalnie:
  window.TopLoader = {
    initialized: true,
    start,
    done,
    set,
  };
  return window.TopLoader;
};

export default topLoader;
